export interface FilterDataType {
  dbValue: string;
  name: string;
  name_zh: string;
}

export const SPECIALTY_DATA: FilterDataType[] = [
  { name: 'All', dbValue: 'All', name_zh: '全選' },
  {
    name: 'General Practitioner',
    dbValue: 'General Practitioner',
    name_zh: '\u57FA\u5C64\u4FDD\u5065\u79D1',
  },
  { name: 'Cardiology', dbValue: 'Cardiology', name_zh: '\u5FC3\u81DF\u79D1' },
  {
    name: 'Cardiothoracic Surgery',
    dbValue: 'Cardiothoracic Surgery',
    name_zh: '\u5FC3\u80F8\u5916\u79D1',
  },
  { name: 'Chinese Herbalist', dbValue: 'TCM', name_zh: '\u4E2D\u91AB' },
  {
    name: 'Clinical Oncology',
    dbValue: 'Clinical Oncology',
    name_zh: '\u81E8\u5E8A\u816B\u7624\u79D1',
  },
  { name: 'Dermatology', dbValue: 'Dermatology', name_zh: '\u76AE\u819A\u79D1' },
  {
    name: 'Endocrinology, Diabetes & Metabolism',
    dbValue: 'Endocrinology, Diabetes & Metabolism',
    name_zh: '\u5167\u5206\u6CCC\u53CA\u7CD6\u5C3F\u79D1',
  },
  {
    name: 'Gastroenterology & Hepatology ',
    dbValue: 'Gastroenterology & Hepatology ',
    name_zh: '\u8178\u80C3\u809D\u81DF\u79D1',
  },
  { name: 'General Surgery', dbValue: 'General Surgery', name_zh: '\u5916\u79D1' },
  { name: 'Geriatric Medicine', dbValue: 'Geriatric Medicine', name_zh: '\u8001\u4EBA\u79D1' },
  { name: 'Gynaecology', dbValue: 'Gynaecology', name_zh: '\u5A66\u79D1' },
  {
    name: 'Haematology & Haematological Oncology',
    dbValue: 'Haematology & Haematological Oncology',
    name_zh: '\u8840\u6DB2\u53CA\u8840\u6DB2\u816B\u7624\u79D1',
  },
  { name: 'Internal Medicine', dbValue: 'Internal Medicine', name_zh: '\u5167\u79D1' },
  {
    name: 'Laboratory and Imaging Centre',
    dbValue: 'Laboratory',
    name_zh: '\u5316\u9a57\uff0f\u91ab\u7642\u5f71\u50cf\u4e2d\u5fc3',
  },
  { name: 'Medical Oncology', dbValue: 'Medical Oncology', name_zh: '\u816B\u7624\u5167\u79D1' },
  { name: 'Nephrology', dbValue: 'Nephrology', name_zh: '\u814E\u79D1' },
  { name: 'Neurology', dbValue: 'Neurology', name_zh: '\u8166\u795E\u7D93\u79D1' },
  { name: 'Neurosurgery', dbValue: 'Neurosurgery', name_zh: '\u8166\u5916\u79D1' },
  {
    name: 'Obstetrics & Gynaecology',
    dbValue: 'Obstetrics & Gynaecology',
    name_zh: '\u5A66\u7522\u79D1',
  },
  { name: 'Oncology', dbValue: 'Oncology', name_zh: '\u816B\u7624\u79D1' },
  { name: 'Ophthalmology', dbValue: 'Ophthalmology', name_zh: '\u773C\u79D1' },
  {
    name: 'Orthopaedics & Traumatology',
    dbValue: 'Orthopaedics & Traumatology',
    name_zh: '\u9AA8\u79D1',
  },
  {
    name: 'Otorhinolaryngology',
    dbValue: 'Otorhinolaryngology',
    name_zh: '\u8033\u9F3B\u5589\u79D1',
  },
  {
    name: 'Paediatric Surgery',
    dbValue: 'Paediatric Surgery',
    name_zh: '\u5C0F\u5152\u5916\u79D1',
  },
  { name: 'Paediatrics', dbValue: 'Paediatrics', name_zh: '\u5152\u79D1' },
  { name: 'Physiotherapy', dbValue: 'Physiotherapy', name_zh: '\u7269\u7406\u6CBB\u7642' },
  { name: 'Plastic Surgery', dbValue: 'Plastic Surgery', name_zh: '\u6574\u5F62\u5916\u79D1' },
  {
    name: 'Respiratory Medicine',
    dbValue: 'Respiratory Medicine',
    name_zh: '\u547C\u5438\u7CFB\u7D71\u79D1',
  },
  { name: 'Rheumatology', dbValue: 'Rheumatology', name_zh: '\u98A8\u6FD5\u75C5\u79D1' },
  { name: 'Urology', dbValue: 'Urology', name_zh: '\u6CCC\u5C3F\u79D1' },
];

export const CLASSIFICATION_DATA: FilterDataType[] = [
  {
    name: 'All',
    dbValue: 'All',
    name_zh: '\u5168\u90e8\u624b\u8853\u985e\u5225',
  },
  {
    name: 'Minor',
    dbValue: 'MINOR',
    name_zh: '\u5c0f\u578b\u624b\u8853',
  },
  {
    name: 'Intermediate',
    dbValue: 'INTERMEDIATE',
    name_zh: '\u4e2d\u578b\u624b\u8853',
  },
  {
    name: 'Major',
    dbValue: 'MAJOR',
    name_zh: '\u5927\u578b\u624b\u8853',
  },
  {
    name: 'Complex',
    dbValue: 'COMPLEX',
    name_zh: '\u8907\u96dc\u624b\u8853',
  },
];
